import { useFeatureFlags } from "@evidenceb/athena-common/modules/FeatureFlags";
import React from "react";
import TabTitle from "../../../../../components/TabTitle/TabTitle";
import { pageTitles } from "../../../../../utils/messages";
import { ResourceSeriesFlowOverrideProvider } from "../../../../../components/Player/ResourceSeriesFlowOverride/ResourceSeriesFlowOverrideContext";
import Player from "../../../../../components/Player/Player";
import TeacherPlayerInfoPanel from "./TeacherPlayerInfoPanel/TeacherPlayerInfoPanel";
import SoloTeacherResourceSeriesProvider from "./SoloTeacherResourceSeriesProvider";
import TeacherHeader from "./TeacherHeader/TeacherHeader";
import ModuleResourceSeriesSummary from "../../../../../components/Player/ResourceSeriesSummary/ModesResourceSeriesSummary/ModuleResourceSeriesSummary";
import { withExercises } from "../../../../../hooks/queries/useExercisesQuery";

const TeacherPlayer = () => {
    const features = useFeatureFlags();

    return (
        <>
            <TabTitle title={pageTitles.teacherSoloAIPlayer} />
            <ResourceSeriesFlowOverrideProvider>
                <SoloTeacherResourceSeriesProvider>
                    <Player
                        InfoPanel={
                            features.teacherInfoPanel
                                ? TeacherPlayerInfoPanel
                                : undefined
                        }
                        ResourceSeriesSummary={ModuleResourceSeriesSummary}
                        Header={TeacherHeader}
                    />
                </SoloTeacherResourceSeriesProvider>
            </ResourceSeriesFlowOverrideProvider>
        </>
    );
};
export default withExercises(TeacherPlayer);
